var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.href === '' ? _vm.tagName : 'a',{tag:"compnent",staticClass:"oct-button",class:[
    {
      'oct-button--outlined': _vm.outline,
    },
    ("oct-button--" + _vm.type),
    ("oct-button--" + _vm.size),
    ("oct-button--align-" + _vm.align)
  ],attrs:{"href":_vm.href === '' ? false : _vm.href}},[(_vm.icon)?_c('oct-icon',{staticClass:"oct-button__leading-icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }